import { render, staticRenderFns } from "./editJudgeAccount.vue?vue&type=template&id=2e668440&scoped=true"
import script from "./editJudgeAccount.vue?vue&type=script&lang=js"
export * from "./editJudgeAccount.vue?vue&type=script&lang=js"
import style0 from "./editJudgeAccount.vue?vue&type=style&index=0&id=2e668440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e668440",
  null
  
)

export default component.exports